import { createRoute, type AnyRoute } from "@tanstack/react-router";
import { Map } from "lucide-react";

import { PlaceholderPage } from "@/components/cinch/PlaceholderPage";
import type { FeatureModule } from "@/features/types";
import { guarded } from "@/lib/auth";

function JourneysPage() {
  return (
    <PlaceholderPage
      title="Journey Monitoring"
      description="Observe and debug customer + operational journeys in real time."
      icon={Map}
      plannedCapabilities={[
        "Live journey runs with stage timing",
        "Stuck-state alerts and auto-escalation",
        "Step-by-step inspector with payload diff",
        "Replay and retry from any step",
      ]}
    />
  );
}

export const journeysModule: FeatureModule = {
  key: "journeys",
  nav: {
    label: "Journeys",
    icon: Map,
    to: "/journeys",
    requires: "journeys.read",
    order: 10,
    group: "Monitors",
  },
  routes: (rootRoute) => [
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/journeys",
      component: guarded("journeys.read", JourneysPage),
    }),
  ] as unknown as AnyRoute[],
};
